<p-toast></p-toast>
<div class="modal-body" *ngIf="!showPreviousReport && dataLoaded && nmvtisMessageModel?.nmvtisResponse">
    <form [formGroup]="psvrForm" autocomplete="off">
        <div class="spinner" *ngIf="!dataLoaded"></div>
        <h2>Vehicle</h2>
        <fieldset>
            <div class="row">
                <div class="col-sm-5 col-md-4 mvd_form-group">
                    <label>VIN</label>
                    <div class="mvd_form-control">{{existingReport.nmvtisvin}}</div>
                </div>

                <div class="col-sm-2 mvd_form-group">
                    <label>Year</label>
                    <div class="mvd_form-control">{{existingReport.nmvtisModelYear}}</div>
                </div>
                <div class="col-sm-3 mvd_form-group">
                    <label>Make</label>
                    <div class="mvd_form-control">{{existingReport.nmvtisMake}}</div>
                </div>
                <div class="col-sm-3 mvd_form-group">
                    <label>Model</label>
                    <div class="mvd_form-control">{{existingReport.nmvtisModel}}</div>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-6 col-md-5 col-lg-4 mvd_form-group">
                    <label>Owner Name</label>
                    <div class="mvd_form-control">{{ownerName}}</div>
                </div>
                <div class="col-sm-5 col-md-4 col-lg-3 mvd_form-group" *ngIf="ownerName">
                    <label>Owner - {{ownerIdentificationTypeId | displayValue:customerIdentificationTypes}}</label>
                    <div class="mvd_form-control">{{ownerIdentificationNumber}}</div>
                </div>
            </div>
        </fieldset>

        <h2>Agent</h2>
        <fieldset>
            <div class="row">
                <div class="col-sm-6 col-md-5 col-lg-4 mvd_form-group">
                    <label>Name</label>
                    <div class="mvd_form-control">{{agentName}}</div>
                </div>
                <div class="col-sm-4 col-md-3 col-lg-2 mvd_form-group">
                    <label>{{agentIdentificationTypeId | displayValue:customerIdentificationTypes}}</label>
                    <div class="mvd_form-control">{{agentIdentificationNumber}}</div>
                </div>

            </div>
        </fieldset>

        <h2>NMVTIS Report</h2>
        <fieldset>
            <div class="row" *ngIf="nmvtisMessageModel?.nmvtisResponse?.vehicleSummary">
                <div class="col-sm-6 col-md-3 mvd_form-group">
                    <label>VIN</label>
                    <div class="mvd_form-control">{{nmvtisMessageModel.nmvtisResponse.vehicleSummary.vehicleIdentification}}</div>
                </div>

                <div class="col-sm-6 col-md-3 mvd_form-group">
                    <label>Year</label>
                    <div class="mvd_form-control">{{this.nmvtisMessageModel.nmvtisResponse.vehicleSummary.itemModelYearDate}}</div>
                </div>

                <div class="col-sm-6 col-md-3 mvd_form-group">
                    <label>Make</label>
                    <div class="mvd_form-control">{{this.nmvtisMessageModel.nmvtisResponse.vehicleSummary.vehicleMakeCode}}</div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6 col-md-3 mvd_form-group">
                    <label>Case#</label>
                    <div class="mvd_form-control">{{existingReport.nmvtisCaseNumber}}</div>
                </div>


                <div class="col-sm-6 col-md-3 mvd_form-group">
                    <label>Reporting Agency</label>
                    <div class="mvd_form-control">{{existingReport.nmvtisReportingAgency}}</div>
                </div>
                <div class="col-sm-6 col-md-3 mvd_form-group">
                    <label>State</label>
                    <div class="mvd_form-control">{{existingReport.nmvtisReportingJurisdiction}}</div>
                </div>

                <div class="col-sm-6 col-md-3 mvd_form-group">
                    <label>Theft Status Date</label>
                    <div class="mvd_form-control">{{existingReport.nmvtisTheftStatusDate | shortDate}}</div>
                </div>
                <div class="col-sm-6 col-md-3 mvd_form-group">
                    <label>Stolen Parts?</label>
                    <div class="mvd_form-control" *ngIf="existingReport.isPartsStolen">Yes</div>
                    <div class="mvd_form-control" *ngIf="!existingReport.isPartsStolen">No</div>
                 </div>

                <div class="col-sm-6 col-md-3 mvd_form-group">
                    <label>Stolen Parts Description</label>
                    <div class="mvd_form-control">{{nmvtisMessageModel.nmvtisResponse.theftReport.vehiclePartDescriptionText}}</div>
                </div>
                <div class="col-sm-6 col-md-5 col-lg-4 mvd_form-group">
                    <label>Stolen Part Type</label>
                    <select class="mvd_form-control" formControlName="vehiclePartStolenTypeId">
                        <option value="0">- Select -</option>
                        <option *ngFor="let vehiclePartStolenType of vehiclePartStolenTypes" value="{{vehiclePartStolenType.id}}">{{vehiclePartStolenType.displayValue}}</option>
                    </select>
                </div>
            </div>
        </fieldset>

        <h2>Theft Report</h2>
        <fieldset>
            <div class="row">
                <div class="col-sm-4 col-md-2 mvd_form-group">
                    <label>Status</label>
                    <div class="mvd_form-control"><ng-container *ngIf="existingReport.nmvtisStolenVehicleReportStatusTypeId">{{existingReport.nmvtisStolenVehicleReportStatusTypeId | displayValue:stolenVehicleReportStatusTypes}}</ng-container></div>
                </div>

                <div class="col-sm-4 col-md-2 mvd_form-group" *ngIf="previousReport">
                    <label>NMVTIS Run</label>
                    <div class="mvd_form-control"><a href="javascript:void(0)" (click)="showReadonlyReport()">{{previousReport.reportPreparedDate | shortDate}}</a></div>
                </div>
                <div class="col-sm-4 col-md-2 mvd_form-group">
                    <label>Date Prepared</label>
                    <div class="mvd_form-control">{{existingReport.reportPreparedDate | shortDate}}</div>
                </div>

                <div class="col-sm-6 col-md-3 mvd_form-group">
                    <label>Preparer ID</label>
                    <div class="mvd_form-control">{{user.name}}</div>
                </div>
                <div class="col-sm-6 col-md-3 mvd_form-group">
                    <label>Business Service</label>
                    <div class="mvd_form-control">{{existingReport.businessTransactionTypeId | displayValue:businessTransactionTypes}}</div>
                </div>
            </div>
        </fieldset>

        <h2>Questions</h2>
        <fieldset>
            <div class="row" *ngIf="existingReport">
                <div class="col-sm-6 col-md-5 col-lg-4 mvd_form-group">
                    <label>Ref to MVD Enforcement for Inspection?</label>
                    <select class="mvd_form-control" formControlName="referredMVDTypeID">
                        <option [ngValue]="false">No</option>
                        <option [ngValue]="true">Yes</option>
                    </select>
                    <control-validation-messages control="referredMVDTypeID"></control-validation-messages>
                </div>
                <div class="col-sm-6 col-md-5 col-lg-4 mvd_form-group">
                    <label>Called Reporting Agency??</label>
                    <select class="mvd_form-control" formControlName="calledReportingAgencyTypeID">
                        <option [ngValue]="false">No</option>
                        <option [ngValue]="true">Yes</option>
                    </select>
                    <control-validation-messages control="calledReportingAgencyTypeID"></control-validation-messages>
                </div>
                <div class="col-sm-6 col-md-5 col-lg-4 mvd_form-group" *ngIf="psvrForm.controls['calledReportingAgencyTypeID'].value">
                    <label class="required" title="* Required">Agent Name</label>
                    <input class="mvd_form-control" type="text" formControlName="nmvtisReportingAgentName" />

                </div>
                <div class="col-sm-2 col-md-1 mvd_form-group" *ngIf="psvrForm.controls['calledReportingAgencyTypeID'].value">
                    <label class="required" title="* Required">Badge#</label>
                    <input class="mvd_form-control" type="text" formControlName="nmvtisReportingAgentBadgeNumber" />
                </div>
                <div class="col-sm-4 col-md-2 mvd_form-group" *ngIf="psvrForm.controls['calledReportingAgencyTypeID'].value">
                    <label class="required" title="* Required">Agency Status</label>
                    <select class="mvd_form-control" formControlName="agencyStatusTypeID">
                        <option value="0">- Select -</option>
                        <option *ngFor="let agencyStatusType of agencyStatusTypes" value="{{agencyStatusType.id}}">{{agencyStatusType.displayValue}}</option>
                    </select>

                </div>
            </div>

            <h2 *ngIf="existingReport.isNMVTISReportingAgencyCalled">Reporting Agency Remarks</h2>
            <div class="mvd_form-group" *ngIf="psvrForm.controls['calledReportingAgencyTypeID'].value">
                <textarea rows="4" cols="10" formControlName="nmvtisReportingAgencyRemarks"></textarea>
                <div class="mvd_alert__validation">
                    <div class="mvd_alert__rule" *ngIf="hasValidationError('nmvtisReportingAgencyRemarks', 'maxlength')">Reporting Agency Remarks has a maximum length of {{psvrForm.controls['nmvtisReportingAgencyRemarks'].errors.maxlength.requiredLength}} characters</div>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-6 col-md-5 col-lg-4 mvd_form-group">
                    <label>Called Local Law Enforcement?</label>
                    <select class="mvd_form-control" formControlName="leCalledTypeID">
                        <option [ngValue]="false">No</option>
                        <option [ngValue]="true">Yes</option>
                    </select>
                    <control-validation-messages control="leCalledTypeID"></control-validation-messages>
                </div>

                <div class="col-sm-6 col-md-5 col-lg-4 mvd_form-group" *ngIf="psvrForm.controls['leCalledTypeID'].value">
                    <label class="required" title="* Required">Agent Name</label>
                    <input class="mvd_form-control" type="text" formControlName="leAgentName" />
                </div>
                <div class="col-sm-4 col-md-3 col-lg-2 mvd_form-group" *ngIf="psvrForm.controls['leCalledTypeID'].value">
                    <label class="required" title="* Required">Badge#</label>
                    <input class="mvd_form-control" type="text" formControlName="leaBadgeNumber" />
                </div>

                <div class="col-sm-5 col-md-4 col-lg-3 mvd_form-group" *ngIf="psvrForm.controls['leCalledTypeID'].value">
                    <label class="required" title="* Required">LE Status</label>
                    <select class="mvd_form-control" formControlName="leStatusTypeID">
                        <option value="0">- Select -</option>
                        <option *ngFor="let agencyStatusType of agencyStatusTypes" value="{{agencyStatusType.id}}">{{agencyStatusType.displayValue}}</option>
                    </select>
                </div>
            </div>

            <h2 *ngIf="psvrForm.controls['leCalledTypeID'].value">LE Remarks</h2>
            <div class="mvd_form-group" *ngIf="psvrForm.controls['leCalledTypeID'].value">
                <textarea rows="4" cols="9" formControlName="leaRemarks"></textarea>
                <div class="mvd_alert__validation">
                    <div class="mvd_alert__rule" *ngIf="hasValidationError('leaRemarks', 'maxlength')">LEA Remarks has a maximum length of {{psvrForm.controls['leaRemarks'].errors.maxlength.requiredLength}} characters</div>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-6 col-md-4 mvd_form-group">
                    <label class="required" title="* Required">Finding</label>
                    <select class="mvd_form-control" formControlName="findingTypeID" (change)="setActionType($event)">
                        <option value="0">- Select -</option>
                        <option *ngFor="let findingType of findingTypes" value="{{findingType.id}}">{{findingType.displayValue}}</option>
                    </select>
                    <control-validation-messages control="findingTypeID"></control-validation-messages>
                </div>

                <div class="col-sm-6 col-md-4 mvd_form-group">
                    <label class="required" title="* Required">Action Taken</label>
                    <select class="mvd_form-control" formControlName="actionTypeID">
                        <option value="0">- Select -</option>
                        <option *ngFor="let actionType of filteredActionTakenTypes" value="{{actionType.id}}">{{actionType.displayValue}}</option>
                    </select>
                    <control-validation-messages control="actionTypeID"></control-validation-messages>
                </div>
                <div class="col-sm-6 col-md-4 mvd_form-group" *ngIf="isFindingOkToProceed()">
                    <label>Ok to Process Reason</label>
                    <input class="mvd_form-control" type="text" formControlName="reasonToProceed" />
                </div>
            </div>

            <h2>Additional Remarks</h2>
            <div class="mvd_form-group">
                <textarea rows="4" cols="10" formControlName="additionalRemarks"></textarea>
                <div class="mvd_alert__validation">
                    <div class="mvd_alert__rule" *ngIf="hasValidationError('additionalRemarks', 'maxlength')">Additional Remarks has a maximum length of {{psvrForm.controls['additionalRemarks'].errors.maxlength.requiredLength}} characters</div>
                </div>
            </div>
            <div class="mvd_form-group">
                <h2>Previous Remarks</h2>
                <textarea rows="4" cols="10" formControlName="previousRemarks"></textarea>
            </div>
        </fieldset>
    </form>
</div>

<div class="modal-body" *ngIf="showPreviousReport && previousReport">
    <div class="spinner" *ngIf="!dataLoaded"></div>
    <fieldset>
        <h3>Vehicle</h3>
        <div class="row">
            <div class="col-sm-4 mvd_form-group">
                <label>VIN</label>
                <div class="mvd_form-control">{{previousReport.nmvtisvin}}</div>
            </div>

            <div class="col-sm-2 mvd_form-group">
                <label>Year</label>
                <div class="mvd_form-control">{{previousReport.nmvtisModelYear}}</div>
            </div>
            <div class="col-sm-3 mvd_form-group">
                <label>Make</label>
                <div class="mvd_form-control">{{previousReport.nmvtisMake}}</div>
            </div>
            <div class="col-sm-3 mvd_form-group">
                <label>Model</label>
                <div class="mvd_form-control">{{previousReport.nmvtisModel}}</div>
            </div>
        </div>

        <h3 class="divider">Owner</h3>
        <div class="row">
            <div class="col-sm-6 col-md-3 mvd_form-group">
                <label>Name</label>
                <div class="mvd_form-control">{{previousOwnerName}}</div>
            </div>
            <div class="col-sm-6 col-md-3 mvd_form-group">
                <label>{{previousOwnerIdentificationTypeId | displayValue:customerIdentificationTypes}}</label>
                <div class="mvd_form-control">{{previousOwnerNumber}}</div>
            </div>
        </div>
    </fieldset>

    <h2>Agent</h2>
    <fieldset>
        <div class="row">
            <div class="col-sm-6 col-md-3 mvd_form-group">
                <label>Name</label>
                <div class="mvd_form-control">{{previousAgentName}}</div>
            </div>
            <div class="col-sm-6 col-md-3 mvd_form-group">
                <label>{{previousAgentIdentificationTypeId | displayValue:customerIdentificationTypes}}</label>
                <div class="mvd_form-control">{{previousAgentNumber}}</div>
            </div>

        </div>
    </fieldset>

    <h2>NMVTIS Report</h2>
    <fieldset>
        <div class="row">
            <div class="col-sm-6 col-md-3 mvd_form-group">
                <label>Case#</label>
                <div class="mvd_form-control">{{previousReport.nmvtisCaseNumber}}</div>
            </div>


            <div class="col-sm-6 col-md-3 mvd_form-group">
                <label>Reporting Agency</label>
                <div class="mvd_form-control">{{previousReport.nmvtisReportingAgency}}</div>
            </div>
            <div class="col-sm-6 col-md-3 mvd_form-group">
                <label>State</label>
                <div class="mvd_form-control">{{previousReport.nmvtisReportingJurisdiction}}</div>
            </div>

            <div class="col-sm-6 col-md-3 mvd_form-group">
                <label>Theft Status Date</label>
                <div class="mvd_form-control">{{previousReport.nmvtisTheftStatusDate | shortDate}}</div>
            </div>
            <div class="col-sm-6 col-md-3 mvd_form-group">
                <label>Stolen Parts?</label>
                <div *ngIf="previousReport.isPartsStolen" class="mvd_form-control">Yes</div>
                <div *ngIf="!previousReport.isPartsStolen" class="mvd_form-control">No</div>
            </div>

            <div class="col-sm-6 col-md-3 mvd_form-group" *ngIf="previousReport.isPartsStolen">
                <label>Stolen Parts Description</label>
                <div class="mvd_form-control">{{previousReport.vehiclePartStolenTypeId | displayValue:vehiclePartStolenTypes}}</div>
            </div>
        </div>
    </fieldset>

    <h2>Theft Report</h2>
    <fieldset>
        <div class="row">
            <div class="col-sm-4 col-md-2 mvd_form-group">
                <label>Status</label>
                <div class="mvd_form-control"><ng-container *ngIf="previousReport.nmvtisStolenVehicleReportStatusTypeId">{{previousReport.nmvtisStolenVehicleReportStatusTypeId | displayValue:stolenVehicleReportStatusTypes}}</ng-container></div>
            </div>

            <div class="col-sm-4 col-md-2 mvd_form-group">
                <label>Date Prepared</label>
                <div class="mvd_form-control"></div>{{previousReport.reportPreparedDate | shortDate}}
            </div>

            <div class="col-sm-6 col-md-3 mvd_form-group">
                <label>Preparer ID</label>
                <div class="mvd_form-control"></div>{{previousReport.reportPreparedUserLoginId}}
            </div>
            <div class="col-sm-6 col-md-3 mvd_form-group">
                <label>Business Service</label>
                <div class="mvd_form-control"></div>{{previousReport.businessTransactionTypeId | displayValue:businessTransactionTypes}}
            </div>
        </div>
    </fieldset>

    <h2>Questions</h2>
    <fieldset>
        <div class="row" *ngIf="existingReport">
            <div class="col-sm-6 col-md-4 mvd_form-group">
                <label>Ref to MVD Enforcement for Inspection?</label>
                <div class="mvd_form-control" *ngIf="previousReport.isReferredMVD">Yes</div>
                <div class="mvd_form-control" *ngIf="!previousReport.isReferredMVD">No</div>

            </div>
            <div class="col-sm-6 col-md-4 mvd_form-group">
                <label>Called Reporting Agency?</label>
                <div class="mvd_form-control" *ngIf="previousReport.isNMVTISReportingAgencyCalled">Yes</div>
                <div class="mvd_form-control" *ngIf="!previousReport.isNMVTISReportingAgencyCalled">No</div>

            </div>
            <div class="col-sm-4 col-md-2 mvd_form-group" *ngIf="previousReport.isNMVTISReportingAgencyCalled">
                <label class="required" title="* Required">Agent Name</label>
                <div class="mvd_form-control">{{previousReport.nmvtisReportingAgentName}}</div>

            </div>
            <div class="col-sm-2 col-md-1 mvd_form-group" *ngIf="previousReport.isNMVTISReportingAgencyCalled">
                <label>Badge#</label>
                <div class="mvd_form-control">{{previousReport.nmvtisReportingAgentBadgeNumber}}</div>
            </div>

            <div class="col-sm-4 col-md-2 mvd_form-group">
                <label>Agency Status</label>
                <div class="mvd_form-control">{{previousReport.nmvtisReportingAgencyStatusTypeId | displayValue:agencyStatusTypes}}</div>
            </div>

        </div>
        <h2>Reporting Agency Remarks</h2>
        <div class="mvd_form-group">
            <textarea rows="4" cols="10" formControlName="previousReportnmvtisReportingAgencyRemarks"></textarea>
        </div>

        <div class="row">
            <div class="col-sm-6 col-md-5 col-lg-4 mvd_form-group">
                <label>Called Local Law Enforcement?</label>
                <div class="mvd_form-control" *ngIf="previousReport.isLEACalled">Yes</div>
                <div class="mvd_form-control" *ngIf="!previousReport.isLEACalled">No</div>
            </div>

            <div class="col-sm-6 col-md-5 col-lg-4 mvd_form-group" *ngIf="previousReport.isLEACalled">
                <label>Agent Name</label>
                <div class="mvd_form-control">{{previousReport.leAgentName}}</div>
            </div>
            <div class="col-sm-4 col-md-3 col-lg-2 mvd_form-group" *ngIf="previousReport.isLEACalled">
                <label>Badge#</label>
                <div class="mvd_form-control">{{previousReport.leaBadgeNumber}}</div>
            </div>

            <div class="col-sm-4 col-md-3 col-lg-2 mvd_form-group" *ngIf="previousReport.isLEACalled">
                <label>LE Status</label>
                <div class="mvd_form-control">{{previousReport.leaStatusTypeId | displayValue:agencyStatusTypes}}</div>
            </div>
        </div>

        <ng-container *ngIf="previousReport.isLEACalled">
            <h2>LE Remarks</h2>
            <div class="mvd_form-group">
                <textarea rows="4" cols="10" formControlName="previousReportleaRemarks"></textarea>
            </div>
        </ng-container>

        <div class="row">
            <div class="col-sm-6 col-md-4 mvd_form-group">
                <label>Finding</label>
                <div class="mvd_form-control">{{previousReport.nmvtisFindingTypeId | displayValue:findingTypes}}</div>
            </div>
            <div class="col-sm-6 col-md-4 mvd_form-group">
                <label class="required" title="* Required">Action Taken</label>
                <div class="mvd_form-control">{{previousReport.nmvtisActionTakenTypeId | displayValue:actionTakenTypes}}</div>
            </div>
            <div class="col-sm-6 col-md-4 mvd_form-group" *ngIf="previousReport.reasonToProceed">
                <label>Ok to Process Reason</label>
                <input class="mvd_form-control" type="text" formControlName="previousReportreasonToProceed" />
            </div>
        </div>

        <h2>Additional Remarks</h2>
        <div class="mvd_form-group">
            <textarea rows="4" cols="10" formControlName="previousReportadditionalRemarks"></textarea>
        </div>

        <h2>Previous Remarks</h2>
        <div class="mvd_form-group">
            <textarea rows="4" cols="10" formControlName="existingReportpreviousRemarks"></textarea>
        </div>
    </fieldset>
</div>

<div class="modal-footer" *ngIf="dataLoaded">
    <div class="btn--group">
        <button class="btn--default" type="button" (click)="onCancelClick()">Cancel</button>
        <mvm-spinner-btn [btnText]="'Save'" (clicked)="onSaveClick()" *ngIf="!showPreviousReport"></mvm-spinner-btn>
    </div>
</div>